module.exports = __webpack_public_path__ + "static/img/icon_hitem8.9b36926.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_hitem8.png
// module id = LsDp
// module chunks = 21